import { EaseChatClient } from '@/IM/initwebsdk'
import { useImConversationStore, useImMessageStore  } from '@/store'

export const imReviceMessageListener = () => {
    const mountReviceMessageEventListener = () => {
        EaseChatClient.addEventHandler('messageListen', {
            // 收到文本消息
            onTextMessage: function (message) {
                // 判断是否是收到正在聊天的对象. 是就更新消息列表
                if (useImMessageStore().currentChat.conversationId === message.from) {
                    useImMessageStore().updateMessageList(message)
                }
                // 更新会话列表
                setTimeout(() => useImConversationStore().getConversationList(), 1000)
            }, 
            // 收到自定义消息
            onCustomMessage: function (message) {
                // 判断是否是收到正在聊天的对象. 是就更新消息列表
                if (useImMessageStore().currentChat.conversationId === message.from) {
                    useImMessageStore().updateMessageList(message)
                }
                // 更新会话列表
                setTimeout(() => useImConversationStore().getConversationList(), 1000)
            },
        })
    }
    return {
        mountReviceMessageEventListener,
    }
}
